import React, { useState, useEffect } from 'react';

const Loader = ({ stages }: { stages: any }) => {
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    if (currentStage < stages.length - 1) {
      const timer = setTimeout(() => {
        setCurrentStage(currentStage + 1);
      }, stages[currentStage].interval);
      return () => clearTimeout(timer);
    }
  }, [currentStage, stages]);

  return (
    <div className="flex flex-col justify-center items-center">
      <div
        role="status"
        className="m-auto flex flex-col justify-center items-center"
      >
        {stages[currentStage].svg}
        <p className="text-center mt-2">{stages[currentStage].text}</p>
      </div>
    </div>
  );
};

export default Loader;
